export default {
  label: 'Wyślij do',
  counter: '{{current}} z {{max}}',
  default_badge: 'Domyślny',
  remove: 'Usuń {{email}}',
  add_back: 'Dodaj z powrotem',
  empty: 'Dodaj co najmniej jeden adres e-mail.',
  add_label: 'Dodaj adres e-mail',
  placeholder: 'name@example.com',
  add: 'Dodaj',
  hint: 'Maksymalnie {{max}} adresów e-mail. Każdy z nich otrzyma osobną wiadomość.',
  hint_full: 'To maksymalna liczba adresów na tej liście. Usuń adres, aby dodać kolejny.',
  errors: {
    full: 'Możesz dodać maksymalnie {{max}} adresów e-mail.',
    invalid: 'Wpisz adres e-mail w formacie name@example.com.',
    duplicate: 'Adres {{email}} jest już na liście.',
  },
};
